import MuiBox from '@mui/material/Box';
import Box from '../../../Common/Box';
import React from 'react';
import {Theme, useTheme} from "@mui/material/styles";
import uiStore from "../../stores/uiStore";
import {CodeView} from "../../../Common/CodeView";
import {SxProps} from "@mui/material";

export const ThemeJson = React.forwardRef(function ThemeJson(props, ref) {

    const {
        name,
        palette: {
            mode,
            primary,
            background,
        },
        components
    } = useTheme() as Theme & { name: string };


    const themeJson = JSON.stringify({
        name,
        mode,
        palette: {
            primary,
            background,
        },
        components,
    }, null, 2);
    let sx: SxProps;

    if (uiStore.isMobile) {
        sx = {
            height: "200px",
            position: "static",
            overflow: "auto",
            padding: "0px 30px 30px 20px",
        }
    }

    return <MuiBox
            ref={ref}
            sx={{
                position: "absolute",
                left: "0",
                width: uiStore.isMobile ? "100%" : "25%",
                height: "100%",
                padding: "110px 30px 30px 20px",
                ...sx
            }}>

        <Box
                flex={1}
                fontSize={"12px"}
                overflow={"auto"}

                color={"primary.main"}
                maxHeight={"600px"}
                row
                justifyContent={"center"}
        >
            <CodeView json={themeJson}/>
        </Box>

    </MuiBox>;
})
